// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-field {
    padding: 5px 0 5px 12px !important;
}

input[type=number].number-field::-webkit-inner-spin-button {
    height: 40px !important;
}

.profile-input-error-message {
    color: red;
    font-size: 11px;
    line-height: 16px;
    margin-top: 4px;
}

@media only screen and (max-width: 1024px) {
    .profile-input-error-message {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/SectionTitle/index.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".number-field {\n    padding: 5px 0 5px 12px !important;\n}\n\ninput[type=number].number-field::-webkit-inner-spin-button {\n    height: 40px !important;\n}\n\n.profile-input-error-message {\n    color: red;\n    font-size: 11px;\n    line-height: 16px;\n    margin-top: 4px;\n}\n\n@media only screen and (max-width: 1024px) {\n    .profile-input-error-message {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
